import React from 'react'

const ClockIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask id='path-1-inside-1_3227_233981' fill='white'>
        <path d='M8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z' />
      </mask>
      <path
        d='M8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z'
        fill='#141424'
      />
      <path
        d='M8 0C3.59772 0 0 3.59772 0 8H2C2 4.70228 4.70228 2 8 2V0ZM0 8C0 12.4023 3.59772 16 8 16V14C4.70228 14 2 11.2977 2 8H0ZM8 16C12.4023 16 16 12.4023 16 8H14C14 11.2977 11.2977 14 8 14V16ZM16 8C16 3.59772 12.4023 0 8 0V2C11.2977 2 14 4.70228 14 8H16ZM8 13C5.25229 13 3 10.7477 3 8H1C1 11.8523 4.14772 15 8 15V13ZM3 8C3 5.25229 5.25229 3 8 3V1C4.14772 1 1 4.14772 1 8H3ZM8 3C10.7477 3 13 5.25229 13 8H15C15 4.14772 11.8523 1 8 1V3ZM13 8C13 10.7477 10.7477 13 8 13V15C11.8523 15 15 11.8523 15 8H13Z'
        fill='#141424'
        mask='url(#path-1-inside-1_3227_233981)'
      />
      <mask id='path-3-inside-2_3227_233981' fill='white'>
        <path d='M8.5 4H7.5V8.5V9.05V9.5H12V8.5H8.5V4Z' />
      </mask>
      <path d='M8.5 4H7.5V8.5V9.05V9.5H12V8.5H8.5V4Z' fill='#141424' />
      <path
        d='M8.5 4H9.5V3H8.5V4ZM7.5 4V3H6.5V4H7.5ZM7.5 9.5H6.5V10.5H7.5V9.5ZM12 9.5V10.5H13V9.5H12ZM12 8.5H13V7.5H12V8.5ZM8.5 8.5H7.5V9.5H8.5V8.5ZM8.5 3H7.5V5H8.5V3ZM6.5 4V8.5H8.5V4H6.5ZM6.5 8.5V9.05H8.5V8.5H6.5ZM6.5 9.05V9.5H8.5V9.05H6.5ZM7.5 10.5H12V8.5H7.5V10.5ZM13 9.5V8.5H11V9.5H13ZM12 7.5H8.5V9.5H12V7.5ZM9.5 8.5V4H7.5V8.5H9.5Z'
        fill='#141424'
        mask='url(#path-3-inside-2_3227_233981)'
      />
    </svg>
  )
}

export default ClockIcon
